import React from 'react'
import { FormattedMessage } from 'react-intl'
import Link from 'redux-first-router-link'
import ArticleActivitySummary from './ArticleActivitySummary'
import FollowableUser from 'components/FollowableUser'
import GroupSummary from 'components/GroupSummary'
import PersonName from 'components/PersonName'
import styles from './ActivityObject.css'

const ActivityObject = ({
  verb,
  object,
  actor,
  target,
  origin,
  group,
  you,
  showActor,
  users,
  reactions,
  aggregated_mode
}) => {
  switch (verb) {
    case 'publish':
    case 'removed-post':
      return (
        <ArticleActivitySummary
          article={object}
          actor={showActor ? actor : null}
          users={users}
        />
      )
    case 'follow':
      if (object._id === you._id) {
        return (
          <FollowableUser user={actor} className={styles.followable_user} />
        )
      } else {
        return (
          <FollowableUser user={object} className={styles.followable_user} />
        )
      }
    case 'reply':
      return (
        <ArticleActivitySummary
          target={target}
          article={object}
          actor={showActor ? actor : null}
          users={users}
        />
      )
    case 'react':
      return null
    case 'create-group':
    case 'created-group':
    case 'join':
    case 'join-group':
    case 'joined-group':
    case 'invite-to-group':
    case 'close-group':
    case 'reopen-group':
      let g = group || object
      return <GroupSummary group={g} />
    case 'request-access':
      g = group || object
      return (
        <div className={styles.access_request}>
          {aggregated_mode ? (
            <span>
              <PersonName person={actor} you={you} />
              <FormattedMessage id="activity.request-access" values={g} />
            </span>
          ) : null}
          <Link
            to={{
              type: `groups/group/membership/access_requests`,
              payload: {
                group: g._id
              }
            }}
          >
            <FormattedMessage id="group.access_requests.manage" />
          </Link>
        </div>
      )
    default:
      return (
        <span>
          A strange and unidentified event occurred. Mysteries abound.
        </span>
      )
  }
}

export default ActivityObject
